import { render, staticRenderFns } from "./showPkPreviews.vue?vue&type=template&id=1be9cf08&scoped=true"
import script from "./showPkPreviews.vue?vue&type=script&lang=js"
export * from "./showPkPreviews.vue?vue&type=script&lang=js"
import style0 from "./showPkPreviews.vue?vue&type=style&index=0&id=1be9cf08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9cf08",
  null
  
)

export default component.exports